import React, { useEffect, useMemo } from "react";
import {
  Box,
  Grid,
  MenuItem,
  Paper,
  Select,
  Button,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  updateDiningMenu,
  addDiningMenu,
  removeDiningMenu,
} from "../../Redux/slices/addEnquirySlice";
import {  align_column, VM_Colors } from "../../Styles/VMStyles";
import MUITypography from "../../Components/MUITypography";
import MuiTypographyMandatory from "../../Components/Custom/MuiTypographyMandatory";
import DeleteIcon from "@mui/icons-material/Delete";
import StyledInputField from "../../Components/Custom/StyledInputField";
import { MENU_OPTIONS } from "../../Util/VMConstants";

function AEEventDiningDetails({ tabIndex }) {
  const dispatch = useDispatch();

  // Always default to array
  const diningDetailsRaw = useSelector(
    (state) => state.addEnquiry.events[tabIndex]?.diningDetails
  );

  const diningDetails = useMemo(
    () => (Array.isArray(diningDetailsRaw) ? diningDetailsRaw : []),
    [diningDetailsRaw]
  );

  // 🔹 Auto recalc total when plates/cost change
  useEffect(() => {
    diningDetails.forEach((menu, index) => {
      const plates = parseInt(menu.no_of_plates || 0, 10);
      const cost = parseInt(menu.cost_per_plate || 0, 10);
      const total = plates * cost;

      if (menu.total_menu_cost !== total) {
        dispatch(
          updateDiningMenu({
            eventIndex: tabIndex,
            menuIndex: index,
            field: "total_menu_cost",
            value: total,
          })
        );
      }
    });
  }, [diningDetails, dispatch, tabIndex]);

// 🔹 Ensure at least 1 form exists initially
useEffect(() => {
  if (diningDetails.length === 0) {
    dispatch(addDiningMenu({ eventIndex: tabIndex }));
  }
}, [diningDetails.length, dispatch, tabIndex]);


  const handleMenuChange = (menuIndex, field, value) => {
    dispatch(updateDiningMenu({ eventIndex: tabIndex, menuIndex, field, value }));
  };

  const handleAddMenu = () => {
    const lastMenu = diningDetails[diningDetails.length - 1];
    if (
      lastMenu &&
      (!lastMenu.menu || !lastMenu.no_of_plates || !lastMenu.cost_per_plate)
    ) {
      alert("Please fill out the current menu before adding a new one.");
      return;
    }
    dispatch(addDiningMenu({ eventIndex: tabIndex }));
  };

  const handleDeleteMenu = (menuIndex) => {
    dispatch(removeDiningMenu({ eventIndex: tabIndex, menuIndex }));
  };

  return (
    <Box sx={{ width: "100%",mt: 2}}>
      <Paper sx={{ p: 2 ,backgroundColor:VM_Colors.white1}}>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <MUITypography variant='h3'  >Select Dining (Optional)</MUITypography>
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: "8px",
              fontWeight: "bold",
            }}
            onClick={handleAddMenu}
          >
            + Add Menu
          </Button>
        </Box>

        {/* Menus */}
        {diningDetails.map((menu, index) => (
          <Grid container spacing={2} key={index} alignItems="center" mt={2}>
            {/* Menu Select */}
            <Grid item xs={12} md={3}>
              <Box sx={{ ...align_column, minWidth: "220px" }}>
                <MuiTypographyMandatory label="Menu" />
                <Select
                  fullWidth
                  value={menu.menu || ""}
                  onChange={(e) => handleMenuChange(index, "menu", e.target.value)}
                  sx={{ minWidth: "150px", backgroundColor: VM_Colors.white }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>  -- Select --   </MenuItem>
                  {MENU_OPTIONS.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Grid>

            {/* Plates */}
            <Grid item xs={12} md={2}>
              <Box sx={align_column}>
                <StyledInputField
                  heading = "No. of Plates" 
                  type="number"
                  fullWidth
                  value={menu.no_of_plates || ""}
                  onChange={(e) => handleMenuChange(index, "no_of_plates", e.target.value)}
                />
              </Box>
            </Grid>

            {/* Cost */}
            <Grid item xs={12} md={2}>
              <Box sx={align_column}>
                <StyledInputField
                  heading = "Cost per Plate" 
                  type="number"
                  fullWidth
                  value={menu.cost_per_plate || ""}
                  onChange={(e) => handleMenuChange(index, "cost_per_plate", e.target.value)}
                />
              </Box>
            </Grid>

            {/* Total */}
            <Grid item xs={12} md={3}>
              <Box sx={align_column}>
                  <StyledInputField
                  heading = "Total Amount" 
                  fullWidth 
                  value={menu.total_menu_cost || 0} 
                  disabled />
              </Box>
            </Grid>

            {/* Delete Button */}
            <Grid item xs={12} md={2} pt={2}>
              <IconButton color="error" onClick={() => handleDeleteMenu(index)}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
      </Paper>
    </Box>
  );
}

export default AEEventDiningDetails;
